import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfirmDialogComponent } from './modal-confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ModalConfirmDialogServiceService {

  constructor(private modalService: NgbModal) {}

  confirm(message: string = 'Deseja prosseguir com a ação?'): Promise<boolean> {
    const modalRef = this.modalService.open(ModalConfirmDialogComponent, {
      backdrop: 'static',
      keyboard: false
    });

    modalRef.componentInstance.message = message;

    return modalRef.result
      .then((result) => result === true)
      .catch(() => false);
  }

}
